import apiService from '../apiService'
export const eventNewController = configService => {
  const service = apiService(configService)
  return {
    uploadInternalFile: params => {
      return service.postFormData({
        url: `cms/event/file/internal`,
        params,
      })
    },
    downloadInternal: id => {
      return service.downloadFile({
        url: `cms/event/file/internal/${id}`,
      })
    },
    getInternalFileById: id => {
      return service.get({
        url: `cms/event/${id}/file/internal`,
      })
    },
    getEventItemById: (id, params) => {
      return service.post({
        url: `cms/event/${id}/item`,
        params,
      })
    },
    getExternalFileById: id => {
      return service.get({
        url: `cms/event/${id}/file/external`,
      })
    },
    getEventSupplierById: id => {
      return service.get({
        url: `cms/event/${id}/supplier`,
      })
    },
    uploadEventItemFile: params => {
      return service.post({
        url: `cms/event/item/file`,
        params,
      })
    },
    downloadEventItemFile: id => {
      return service.downloadFile({
        url: `cms/event/item/file/${id}`,
      })
    },
    uploadExternalFile: params => {
      return service.post({
        url: `cms/event/file/external`,
        params,
      })
    },
    downloadExternal: id => {
      return service.downloadFile({
        url: `cms/event/file/external/${id}`,
      })
    },
    downloadProductItem: (event_id, currency_id) => {
      if (event_id && event_id !== '') {
        return service.downloadFile({
          url: `cms/event/${event_id}/item/excel?currency_id=${currency_id}`,
        })
      } else {
        return service.downloadFile({
          url: `cms/event/item/excel?currency_id=${currency_id}`,
        })
      }
    },
    uploadProductItem: formData => {
      return service.uploadFile({
        url: `cms/event/item/excel`,
        formData,
      })
    },
    selectionSupplierAll: (event_id, params) => {
      return service.put({
        url: `cms/buyer/event/${event_id}/compare/select-by-supplier`,
        params,
      })
    },
    getBuyerItemCompare: (event_id, params) => {
      return service.post({
        url: `cms/buyer/event/${event_id}/compare`,
        params,
      })
    },
    eventHistories: event_id => {
      return service.get({
        url: `cms/buyer/event/histories/${event_id}`,
      })
    },
    clearAllSelection: event_id => {
      return service.put({
        url: `cms/buyer/event/${event_id}/compare/clear-selection`,
      })
    },
    selectionSupplier: (event_id, params) => {
      return service.put({
        url: `cms/buyer/event/${event_id}/compare/select-item`,
        params,
      })
    },
    createProject: params => {
      return service.put({
        url: `cms/buyer/project`,
        params,
      })
    },
    getTempSourcingProject: params => {
      return service.get({
        url: `cms/buyer/project`,
        params,
      })
    },
    selectNoSelectionReason: (event_id, params) => {
      return service.post({
        url: `cms/buyer/event/${event_id}/no-selection`,
        params,
      })
    },
    getProjectBuyer: project_id => {
      // const eventId = params.eventId ? params.eventId : encodeURIComponent('')
      return service.get({
        url: `cms/buyer/project/${project_id}`,
      })
    },
    getEventListProjectBuyer: project_id => {
      return service.get({
        url: `cms/buyer/project/${project_id}/event`,
      })
    },
    getEventDetailBuyer: event_id => {
      return service.get({
        url: `cms/buyer/project/event/${event_id}`,
      })
    },

    //supplier
    rfqSupplierEventFile: params => {
      return service.postFormData({
        url: 'cms/supplier/event/supplier/file',
        params,
      })
    },
    rfqSupplierItemFile: params => {
      return service.postFormData({
        url: 'cms/supplier/event/supplier/item/file',
        params,
      })
    },

    // verify email token event
    getVerifyTokenEmail: token => {
      return service.get({
        url: `/cms/buyer/verify/email/token?token=${token}`,
      })
    },
    getEventStatus: () => {
      return service.get({
        url: `cms/buyer/event/status`,
      })
    },
    getEventAwardStatus: () => {
      return service.get({
        url: `cms/buyer/event/award-status`,
      })
    },
    cancelEvent: (event_id, params) => {
      return service.put({
        url: `cms/buyer/event/${event_id}/cancel`,
        params,
      })
    },
    getSavingType: event_id => {
      return service.get({
        url: `cms/buyer/saving-type/${event_id}`,
      })
    },
    getApprovalHistory: event_id => {
      return service.get({
        url: `cms/buyer/approval-history/${event_id}`,
      })
    },
    updateExchangeRate: (params, event_id) => {
      return service.put({
        url: `cms/buyer/event/${event_id}/exchange-rate`,
        params,
      })
    },
    getApproValWorkflow: event_id => {
      return service.get({
        url: `cms/buyer/event/${event_id}/approval-workflow`,
      })
    },
  }
}
